import { render, staticRenderFns } from "./CaptureSettings.vue?vue&type=template&id=6168bf39&"
import script from "./CaptureSettings.vue?vue&type=script&lang=js&"
export * from "./CaptureSettings.vue?vue&type=script&lang=js&"
import style0 from "./CaptureSettings.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports